var _a;
import { __extends } from "tslib";
import { ColorMatrixTask } from './tasks/webgl/ColorMatrixTask';
import { FilterBase } from './FilterBase';
import { ContextGLBlendFactor as BF } from '../base/ContextGLBlendFactor';
import { BlendMode } from '../image/BlendMode';
var DEFAULT_BLEND_MAP = (_a = {},
    _a[''] = [BF.ONE, BF.ONE_MINUS_SOURCE_ALPHA],
    _a[BlendMode.NORMAL] = [BF.ONE, BF.ONE_MINUS_SOURCE_ALPHA],
    _a[BlendMode.LAYER] = [BF.ONE, BF.ONE_MINUS_SOURCE_ALPHA],
    _a[BlendMode.ERASE] = [BF.ZERO, BF.ONE_MINUS_SOURCE_ALPHA],
    _a[BlendMode.ALPHA + '_back'] = [BF.DESTINATION_ALPHA, BF.ZERO],
    _a);
var ColorMatrixFilter = /** @class */ (function (_super) {
    __extends(ColorMatrixFilter, _super);
    function ColorMatrixFilter(props) {
        var _this = _super.call(this) || this;
        _this._blendDst = BF.ONE_MINUS_SOURCE_ALPHA;
        _this._blendSrc = BF.ONE;
        _this._requireBlend = true;
        _this._blend = '';
        _this._copyPixelTask = new ColorMatrixTask();
        _this.addTask(_this._copyPixelTask);
        if (props) {
            _this.applyProps(props);
        }
        return _this;
    }
    Object.defineProperty(ColorMatrixFilter.prototype, "blendDst", {
        get: function () {
            return this._blendDst;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorMatrixFilter.prototype, "blendSrc", {
        get: function () {
            return this._blendSrc;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorMatrixFilter.prototype, "requireBlend", {
        get: function () {
            return this._requireBlend;
        },
        set: function (v) {
            if (!this._requireBlend && v) {
                this.blend = '';
            }
            this._requireBlend = v;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorMatrixFilter.prototype, "blend", {
        get: function () {
            return this._blend;
        },
        set: function (v) {
            var map = DEFAULT_BLEND_MAP[v];
            this._requireBlend = !!map;
            if (map) {
                this._blendDst = map[1];
                this._blendSrc = map[0];
            }
            else {
                // go composite by shader
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorMatrixFilter.prototype, "colorTransform", {
        get: function () {
            return this._copyPixelTask.transform;
        },
        set: function (value) {
            this._copyPixelTask.transform = value;
            if (!value) {
                this._requireBlend = false;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ColorMatrixFilter.prototype, "matrix", {
        get: function () {
            return this._copyPixelTask.matrix;
        },
        set: function (value) {
            this._copyPixelTask.matrix = value;
            if (!value) {
                this._requireBlend = false;
            }
        },
        enumerable: false,
        configurable: true
    });
    ColorMatrixFilter.prototype.applyProps = function (props) {
        this.matrix = props === null || props === void 0 ? void 0 : props.matrix;
    };
    ColorMatrixFilter.filterName = 'colorMatrix';
    return ColorMatrixFilter;
}(FilterBase));
export { ColorMatrixFilter };
